import snackBar from './snackBar.js';
const els = document.querySelectorAll('.snack-bar');

for (let el of els) {
    snackBar(el);
};
